import { CheckboxProps, FormInstance } from "antd";
import { ColumnsType, TableProps } from "antd/lib/table";
import React from "react";

export interface ITableProps<T> extends TableProps<T> {
	readonly dataSource: T[];
	readonly columns: ColumnsType<T>;
	readonly isDraggable?: boolean;
	readonly isTopBorder?: boolean;
	readonly headerBgColor?: boolean;
	readonly loadingIcon?: string;
	readonly onDragEnd?: ({ ...props }: { [x: string]: any }) => void;
	readonly loading: boolean;
	readonly isDragDisabled?: boolean;
	readonly getCheckboxProps?: (
		record: T
	) => Partial<Omit<CheckboxProps, "checked" | "defaultChecked">>;
	readonly useBlueHeader?: boolean;
	readonly draggableRowInDrawers?: boolean;
	readonly allowYScroll?: boolean;
}
export interface EditableCellProps<T> {
	readonly title: React.ReactNode;
	readonly editable: boolean;
	readonly isPrice: boolean;
	readonly isInputNumber: boolean;
	readonly children: React.ReactNode;
	readonly dataIndex: string;
	readonly record: T;
	readonly handleSave: (record: T) => void;
}

export const EditableContext = React.createContext<FormInstance | null>(null);
